import React from "react";
import moment from "moment";
import { FormControl } from "react-bootstrap";

const defaultErrorMessage = {
    min: 'Выходит за пределы минимального значения',
    max: 'Выходит за пределы максимального значения',
}

const getError = (value, min, max, errorMessage) => {
    if (min && value < min) {
        return errorMessage?.min || defaultErrorMessage.min
    } else if (max && value > max) {
        return errorMessage?.max || defaultErrorMessage.max
    } else return null
}

export default ({ value = moment.unix(), onChange = () => { }, onBlur = () => { }, min, max, disabled, errorMessage = {} }) => {

    const handleChange = (newValue, type) => {
        if (!newValue) return;
        let _dateTimeValue = moment.unix(value);
        if (type === 'date') {
            const [year, month, date] = newValue.split('-');
            _dateTimeValue.set('year', year);
            _dateTimeValue.set('month', month - 1);
            _dateTimeValue.set('date', date);
        } else if (type === 'time') {
            const [hour, minute, second] = newValue.split(':');
            _dateTimeValue.set('hour', hour);
            _dateTimeValue.set('minute', minute);
            _dateTimeValue.set('second', second);
        }
        _dateTimeValue = _dateTimeValue.unix();
        onChange(_dateTimeValue);
    }

    const error = getError(value, min, max, errorMessage);

    return <div>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', padding: 2, borderRadius: 5, border: error ? '1px solid red' : 'none' }}>
            <FormControl
                type="date"
                value={moment.unix(value).format('yyyy-MM-DD')}
                onChange={(e) => handleChange(e.target.value, 'date')}
                disabled={disabled}
                onBlur={onBlur}
            />
            <FormControl
                type="time"
                step={1}
                value={moment.unix(value).format('HH:mm:ss')}
                onChange={(e) => handleChange(e.target.value, 'time')}
                disabled={disabled}
                onBlur={onBlur}
            />
        </div>
        {error && <div style={{ marginTop: '0.25rem', color: 'red', fontSize: '1rem' }}>{error}</div>}
    </div>
}